import { defineMessages } from "react-intl";
export default defineMessages({
    header: {
        id: "onboarding.resolve-tenant.header",
        defaultMessage: "Getting things ready...",
        description: "Header content for the resolve tenant screen"
    },
    subHeader: {
        id: "onboarding.resolve-tenant.sub-header",
        defaultMessage: "Next, we'll launch you to space setup",
        description: "Sub-header content for the resolve tenant screen"
    }
});
